import React, { useState } from 'react';
import FormBase from '../../components/forms/FormBase';
import FormField from '../../components/forms/FormField';
import IdentificacaoMunicipio from '../../components/forms/desenvolvimento-produtivo/01_IdentificacaoMunicipio';
import CaracterizacaoSocioeconomica from '../../components/forms/desenvolvimento-produtivo/02_CaracterizacaoSocioeconomica';
import PoliticasPublicas from '../../components/forms/desenvolvimento-produtivo/03_PoliticasPublicas';
import InfraestruturaLogistica from '../../components/forms/desenvolvimento-produtivo/04_InfraestruturaLogistica';
import DadosAmbientais from '../../components/forms/desenvolvimento-produtivo/05_DadosAmbientais';
import InstituicoesGovernanca from '../../components/forms/desenvolvimento-produtivo/06_InstituicoesGovernanca';
import IndicadoresDesenvolvimento from '../../components/forms/desenvolvimento-produtivo/07_IndicadoresDesenvolvimento';
import ObservacoesDiagnostico from '../../components/forms/desenvolvimento-produtivo/08_ObservacoesDiagnostico';
import { FiInfo, FiPlus, FiMinus } from 'react-icons/fi';
import { FormAccessGuard } from '../../hooks/useFormEnabled';
import { FORMS_BY_ID } from '../../config/forms';

const DesenvolvimentoProdutivo = () => {
  const [repeatableFields, setRepeatableFields] = useState({
    programa: [{ id: 1 }],
    apl: [{ id: 1 }],
    conselho: [{ id: 1 }]
  });

  const addRepeatableField = (fieldType) => {
    setRepeatableFields(prev => {
      const newId = prev[fieldType].length > 0 
        ? Math.max(...prev[fieldType].map(item => item.id)) + 1 
        : 1;
      return {
        ...prev,
        [fieldType]: [...prev[fieldType], { id: newId }]
      };
    });
  };

  const removeRepeatableField = (fieldType, id) => {
    setRepeatableFields(prev => ({
      ...prev,
      [fieldType]: prev[fieldType].filter(item => item.id !== id)
    }));
  };

  const sections = [
    {
      title: '1. Identificação do Município/Localidade',
      fields: [
        'nome_municipio',
        'codigo_ibge',
        'populacao',
        'area',
        'idhm',
        'gini',
        'posicao_geografica',
        'posicao_geografica_outra',
        'fontes_principais_secao1',
        'links_acesso_secao1',
      ],
    },
    {
      title: '2. Caracterização Socioeconômica',
      fields: [
        'pib_municipal',
        'participacao_pib',
        'taxa_desemprego',
        'setores_economicos',
        'setores_economicos_outro',
        'exportacoes_importacoes',
        'renda_per_capita',
        'taxa_pobreza',
        'desafios_socioeconomicos',
        'fontes_principais_secao2',
        'links_acesso_secao2',
      ],
    },
    {
      title: '3. Políticas Públicas para o Desenvolvimento Produtivo',
      fields: [
        ...repeatableFields.programa.flatMap(item => [
          `programa_nome_${item.id}`, `programa_foco_${item.id}`, `programa_financiamento_${item.id}`, `programa_resultados_${item.id}`
        ]),
        'presenca_apl',
        'descricao_apl',
        'nome_programa_iniciativa',
        'parcerias',
        'resultados_relatados',
        'infraestrutura_apoio',
        'fontes_principais_secao3',
        'links_acesso_secao3',
      ],
    },
    {
      title: '4. Infraestrutura e Logística',
      fields: [
        'saneamento_basico',
        'energia_eletrica',
        'acesso_internet',
        'qualidade_rodovias',
        'proximidade_centros_logisticos',
        'distancia_aeroporto',
        'fontes_principais_secao4',
        'links_acesso_secao4',
      ],
    },
    {
      title: '5. Dados Ambientais e Sustentabilidade',
      fields: [
        'areas_urbanas',
        'areas_agricolas',
        'areas_preservadas',
        'programa_sustentabilidade',
        'foco_sustentabilidade',
        'parcerias_sustentabilidade',
        'energia_renovavel',
        'fonte_energia',
        'capacidade_instalada',
        'fontes_principais_secao5',
        'links_acesso_secao5',
      ],
    },
    {
      title: '6. Instituições e Governança',
      fields: [
        'presenca_conselhos',
        ...repeatableFields.conselho.flatMap(item => [`conselho_nome_foco_${item.id}`]),
        'orcamento_executado',
        'convenios_ativos',
        'principais_areas',
        'fontes_principais_secao6',
        'links_acesso_secao6',
      ],
    },
    {
      title: '7. Indicadores de Desenvolvimento',
      fields: [
        'idhm_indicador',
        'taxa_crescimento',
        'outros_indicadores',
        'fontes_principais_secao7',
        'links_acesso_secao7',
      ],
    },
    {
      title: '8. Observações e Diagnóstico Preliminar',
      fields: [
        'pontos_fortes',
        'desafios_identificados',
        'sugestoes_politicas',
        'fontes_principais_secao8',
        'links_acesso_secao8',
      ],
    },
  ];

  return (
    <FormBase
      formType="desenvolvimento-produtivo"
      formTitle="Formulário - Políticas Públicas na RIDE-DF (Desenvolvimento Produtivo)"
      formDescription="Preencha os dados sobre políticas públicas de desenvolvimento produtivo na região da RIDE-DF. Os dados coletados serão utilizados para análises e estudos do Observatório Socioeconômico e Ambiental."
      sections={sections}
    >
      {/* Seção 1: Identificação do Município/Localidade */}
      <IdentificacaoMunicipio />

      {/* Seção 2: Caracterização Socioeconômica */}
      <CaracterizacaoSocioeconomica />

      {/* Seção 3: Políticas Públicas para o Desenvolvimento Produtivo */}
      <PoliticasPublicas
        repeatableFields={repeatableFields}
        addRepeatableField={addRepeatableField}
        removeRepeatableField={removeRepeatableField}
      />

      {/* Seção 4: Infraestrutura e Logística */}
      <InfraestruturaLogistica />

      {/* Seção 5: Dados Ambientais e Sustentabilidade */}
      <DadosAmbientais />

      {/* Seção 6: Instituições e Governança */}
      <InstituicoesGovernanca
        repeatableFields={repeatableFields}
        addRepeatableField={addRepeatableField}
        removeRepeatableField={removeRepeatableField}
      />

      {/* Seção 7: Indicadores de Desenvolvimento */}
      <IndicadoresDesenvolvimento />  

      {/* Seção 8: Observações e Diagnóstico Preliminar */}
      <ObservacoesDiagnostico />  
      
    </FormBase>
  );
};

const DesenvolvimentoProdutivoGuarded = () => (
  <FormAccessGuard formId="desenvolvimento-produtivo" formTitle={FORMS_BY_ID['desenvolvimento-produtivo'].title}>
    <DesenvolvimentoProdutivo />
  </FormAccessGuard>
);

export default DesenvolvimentoProdutivoGuarded;
